var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncliMedi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3049 32.6194C36.9228 34.7962 33.4332 38.1362 31.1899 38.535C27.8 39.1498 10.7344 39.1498 7.22825 38.6015C4.51969 38.186 2.09361 35.3778 1.37908 32.8188C0.431915 29.4621 0.29898 17.9632 0.797489 14.3739C1.296 10.7847 4.18735 10.8511 4.35352 14.4072C4.56954 19.2926 3.53929 25.0919 4.1375 30.077C4.51969 33.3173 5.94875 35.0122 9.27214 35.3279C16.1183 35.9594 24.1609 34.979 31.1068 35.1285C32.3697 34.4472 33.7323 33.2342 33.9649 31.7553C34.5798 27.8337 32.9513 14.5733 34.7958 12.247C35.7263 11.0838 37.3216 12.1306 37.3216 12.679V32.6027L37.3049 32.6194Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6804 0.135968C18.9101 -0.0468189 19.9237 -0.0468189 21.1368 0.219052C24.6263 0.950198 32.5859 3.80832 36.0422 5.23737C37.222 5.71927 38.3852 6.20116 38.4849 7.66345C38.003 8.67708 37.4214 8.7934 36.3911 8.67708C31.7716 8.21181 23.3468 3.02732 19.2424 3.02732C16.3677 3.02732 7.34469 7.24803 3.75543 8.22843C2.29314 8.62723 0.481892 9.4747 0 7.38096L1.29612 5.7525L17.6804 0.135968Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_1919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4849,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncliMedi);
export default __webpack_public_path__ + "static/media/incli_medi.b8cb97e2781e08b99c2b9225cea17ba9.svg";
export { ForwardRef as ReactComponent };